var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 29,
    viewBox: "0 0 25 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_336_2307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8571 25.375V27.6406C17.8571 28.3914 17.2575 29 16.5179 29H1.33929C0.599609 29 0 28.3914 0 27.6406V6.79688C0 6.0461 0.599609 5.4375 1.33929 5.4375H5.35714V22.2031C5.35714 23.9521 6.75898 25.375 8.48214 25.375H17.8571ZM17.8571 5.89062V0H8.48214C7.74247 0 7.14286 0.608604 7.14286 1.35938V22.2031C7.14286 22.9539 7.74247 23.5625 8.48214 23.5625H23.6607C24.4004 23.5625 25 22.9539 25 22.2031V7.25H19.1964C18.4598 7.25 17.8571 6.63828 17.8571 5.89062ZM24.6078 4.13312L20.928 0.398127C20.6768 0.143212 20.3362 1.88498e-06 19.981 0L19.6429 0V5.4375H25V5.09431C25 4.7338 24.8589 4.38805 24.6078 4.13312Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_336_2307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.fad34727e64a65df573a2168c21490bc.svg";
export { ForwardRef as ReactComponent };